module.exports = __webpack_public_path__ + "img/report-7.f461ab1e.jpg";